import Icon from "@/v2-ui/icon"
import Tooltip from "@/v2-ui/tooltip"

// The one mark that says a row is gated at all: a small, quiet lock. Most
// rows carry it once the catalogue is tiered, so it must not shout — a pill
// per row turned the editor amber. Everything in these lists is free for
// every customer unless it carries the lock; a package-only item reaches a
// customer only through a live license or an add-on carried by one (or a tick on
// the customer's own list). Spelled out on hover, because it is the first
// thing a salesperson needs to know about a row.
function LicenseFeatureGroupPackageOnlyMark() {
  return (
    <Tooltip>
      <Tooltip.Trigger asChild>
        <span
          role="img"
          aria-label="Package-only"
          className="flex size-4 shrink-0 cursor-help items-center justify-center text-muted-foreground"
        >
          <Icon src="lock" size={12} />
        </span>
      </Tooltip.Trigger>
      <Tooltip.Content side="top" className="max-w-[320px]">
        Package-only: a customer gets this only through a live license or an
        add-on carried by one, or when it is added for them on the
        customer&apos;s Feature access tab. Here the tick is the access. Rows
        without the lock are free for every customer today; a tick on one of
        those is a placement for the day it is made package-only.
      </Tooltip.Content>
    </Tooltip>
  )
}

export default LicenseFeatureGroupPackageOnlyMark
